import gql from 'graphql-tag'

export const UPDATE_WATCHER = gql`
  mutation update_watcher($input: WatcherInput) {
    update_watcher(input: $input)
      @rest(type: "Watcher", path: "/update-watcher", bodyKey: "input", method: "POST") {
      id
      name
      query
      condition
      definition
      last_updated_by
      entity_ids
      entity_type_ids
      interval
      status
      triggered_at
      result
    }
  }
`
